import { render, staticRenderFns } from "./MenuEmanifiestoAA.vue?vue&type=template&id=810b0960&scoped=true&"
import script from "./MenuEmanifiestoAA.vue?vue&type=script&lang=js&"
export * from "./MenuEmanifiestoAA.vue?vue&type=script&lang=js&"
import style0 from "./MenuEmanifiestoAA.vue?vue&type=style&index=0&id=810b0960&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "810b0960",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VList } from 'vuetify/lib/components/VList';
import { VMenu } from 'vuetify/lib/components/VMenu';
installComponents(component, {VBtn,VDivider,VIcon,VList,VMenu})
